export const privyAppId = "cm0lc25u601px13ws7t04sji7";
